// 🖼️ School Images Configuration
// Sabhi images frontend/public/images/ folder mein honi chahiye
import { APP_VERSION } from './version';

const VERSION_PARAM = `?v=${APP_VERSION}`;

export const IMAGES = {
  // Logo
  logo: `/images/logo.png${VERSION_PARAM}`,
  
  // Leadership
  director: `/images/director.jpg${VERSION_PARAM}`,
  principal: `/images/principal.jpg${VERSION_PARAM}`,
  
  // Banner/Hero Section
  banner: `/images/school-banner.jpg${VERSION_PARAM}`,
  
  // Facilities
  scienceLab: `/images/science-lab.jpg${VERSION_PARAM}`,
  computerLab: `/images/computer-lab.jpg${VERSION_PARAM}`,
  library: `/images/library.jpg${VERSION_PARAM}`,
  sportsGround: `/images/sports-ground.jpg${VERSION_PARAM}`,
  
  // About Section
  aboutImage: `/images/school-building.jpg${VERSION_PARAM}`,
  studentsLearning: `/images/students-learning.jpg${VERSION_PARAM}`,
  
  // Events
  annualFunction: `/images/annual-function.jpg${VERSION_PARAM}`,
  sportsDay: `/images/sports-day.jpg${VERSION_PARAM}`,
  
  // Gallery (Default placeholders)
  gallery1: `/images/gallery-1.jpg${VERSION_PARAM}`,
  gallery2: `/images/gallery-2.jpg${VERSION_PARAM}`,
  gallery3: `/images/gallery-3.jpg${VERSION_PARAM}`,
};

export default IMAGES;
